import { createSlice } from "@reduxjs/toolkit";
import { updateUser } from "../actions/adminUserManagement.action";
import { InitialState } from "../interfaces/userManagement.interface";

const initialState: InitialState = {
  isLoading: false,
  data: null,
};

const updateExsistingUser = createSlice({
  name: "Create New User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateUser.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(updateUser.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default updateExsistingUser.reducer;
